import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Wind } from 'lucide-react';
export function UniqueMechanismSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-169">
      {/* Background elements */}
      <div className="absolute inset-0 bg-navy-950" data-id="element-170" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-[400px] bg-radial-gold opacity-40 pointer-events-none" data-id="element-171" />

      <div className="relative z-10 max-w-4xl mx-auto" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-navy-900 border border-gold-500/30 rounded-2xl p-8 md:p-12 box-glow relative overflow-hidden" data-id="element-173">
          {/* Decorative corners */}
          <div className="absolute top-0 left-0 w-16 h-16 border-t border-l border-gold-500/50 rounded-tl-2xl m-4" data-id="element-174" />
          <div className="absolute top-0 right-0 w-16 h-16 border-t border-r border-gold-500/50 rounded-tr-2xl m-4" data-id="element-175" />
          <div className="absolute bottom-0 left-0 w-16 h-16 border-b border-l border-gold-500/50 rounded-bl-2xl m-4" data-id="element-176" />
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b border-r border-gold-500/50 rounded-br-2xl m-4" data-id="element-177" />

          <div className="text-center mb-10" data-id="element-178">
            <h2 className="text-3xl md:text-4xl font-serif text-gold-400 mb-4" data-id="element-179">
              El Método del Escudo de Vacío
            </h2>
            <p className="text-gray-300 italic text-lg" data-id="element-180">
              El secreto de la No-Resonancia
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-181">
            <div className="space-y-6" data-id="element-182">
              <p className="text-gray-300 leading-relaxed text-lg" data-id="element-183">
                En lugar de crear una "barrera" que genera resistencia y
                cansancio, este protocolo te enseña a volverte{' '}
                <strong className="text-white font-normal" data-id="element-184">
                  energéticamente transparente
                </strong>
                .
              </p>
              <p className="text-gray-300 leading-relaxed text-lg" data-id="element-185">
                Al aplicar la No-Resonancia, la energía densa de los demás
                simplemente pasa a través de ti sin encontrar nada donde
                anclarse.
              </p>
            </div>

            <div className="flex flex-col gap-6" data-id="element-186">
              <div className="flex items-start gap-4 p-4 bg-navy-950/50 rounded-lg border border-navy-700 opacity-50" data-id="element-187">
                <ShieldAlert className="w-8 h-8 text-red-400 flex-shrink-0" data-id="element-188" />
                <div data-id="element-189">
                  <h4 className="text-white font-medium mb-1" data-id="element-190">
                    El viejo método
                  </h4>
                  <p className="text-sm text-gray-400" data-id="element-191">
                    Ser un muro que recibe golpes y termina agrietándose.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-navy-800 rounded-lg border border-gold-500/40 shadow-[0_0_15px_rgba(212,175,55,0.1)]" data-id="element-192">
                <Wind className="w-8 h-8 text-gold-400 flex-shrink-0" data-id="element-193" />
                <div data-id="element-194">
                  <h4 className="text-gold-300 font-medium mb-1" data-id="element-195">
                    El Escudo de Vacío
                  </h4>
                  <p className="text-sm text-gray-300" data-id="element-196">
                    Ser el aire que los atraviesa. Intocable. Inalterable.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}